
import { Component, Vue } from 'vue-property-decorator';
import Navbar from '@/components/Navbar.vue';
import Disclaimer from '@/components/Disclaimer.vue';
import * as packageInfo from '../package.json';

@Component({
  components: { Disclaimer, Navbar },
})
export default class App extends Vue {
  disclaimer = false;

  mounted() {
    console.log('App Version: ', packageInfo.version);
  }
}
